module.exports = __webpack_public_path__ + "static/sweetie_1_square-a8d07fa3a6a9896d0941bf2ebe4e46a9.jpg";